import { useDispatch } from 'react-redux';
import { manageCampaignsActions } from 'store/actions';

import { ChartArrowDown, ChartArrowUp } from 'assets/icons';
import { Loader } from 'components';
import * as S from './StatisticBtn.styled';

export const StatisticBtn = ({
  label,
  color,
  value,
  metric,
  isFetchingPrevDataChart,
  avg,
  change,
  numOfDays,
  selectedMetrics,
  isChartHidden,
}) => {
  const dispatch = useDispatch();
  const isSelected = selectedMetrics[metric];

  function handleClick() {
    const newValue = { ...selectedMetrics };
    newValue[metric] = !newValue[metric];

    dispatch(
      manageCampaignsActions.updateProperty({
        propField: 'selectedMetrics',
        newValue: newValue,
      }),
    );
  }

  return (
    <S.OuterContainer onClick={handleClick} isChartHidden={isChartHidden}>
      <S.TopLine color={color} isSelected={isSelected} isChartHidden={isChartHidden}></S.TopLine>
      <S.Container isSelected={isSelected} isChartHidden={isChartHidden}>
        <S.LabelWrap>
          <S.LabelText isSelected={isSelected} isChartHidden={isChartHidden}>
            {label}
          </S.LabelText>
          <S.AnimatedIconButton color={color}></S.AnimatedIconButton>
        </S.LabelWrap>
        <S.DataWrap>
          <S.Value>{value}</S.Value>
          <S.RightContainer>
            <S.SmallText>vs last {numOfDays}d</S.SmallText>
            <S.ChangeContainer change={change}>
              {isFetchingPrevDataChart ? (
                <S.PrevLoaderWrap>
                  <Loader.Local delay={0} />
                </S.PrevLoaderWrap>
              ) : (
                <>
                  {change < 0 && <ChartArrowDown />}
                  {change > 0 && <ChartArrowUp />}
                  <div>{change ? `${Math.abs(change.toFixed(2))}%` : '0'}</div>
                </>
              )}
            </S.ChangeContainer>
          </S.RightContainer>
        </S.DataWrap>
        {<S.Avg>{!!avg && `AVG: ${avg}`}</S.Avg>}
      </S.Container>
    </S.OuterContainer>
  );
};
